export class ConventionMailingInformationExtension {
}
